import { useQuery } from "react-query";
import { AnalyticsArgs } from "../types";
import { filterAnalytics } from "../services/partner/partner.api";

interface UseAnalyticsArgs extends AnalyticsArgs {}

export function useAnalytics(data: UseAnalyticsArgs) {
  const { refetch, ...rest } = useQuery(
    ["analytics", ...Object.values(data)],
    () => filterAnalytics(data),
    {
      enabled: false,
      select: (data) => data.data,
    }
  );

  return {
    fetchAnalytics: refetch,
    ...rest,
  };
}
